export enum HRPartyStatus {
Active,
Paused,
Stopped,
Completed,
}
